__turbopack_context__.v({
  "checkbox": "ApplyFormConsent-module__0ce17q__checkbox",
  "checkboxError": "ApplyFormConsent-module__0ce17q__checkboxError",
  "checkboxIcon": "ApplyFormConsent-module__0ce17q__checkboxIcon",
  "checkboxLabel": "ApplyFormConsent-module__0ce17q__checkboxLabel",
  "column": "ApplyFormConsent-module__0ce17q__column",
  "columns": "ApplyFormConsent-module__0ce17q__columns",
  "consentText": "ApplyFormConsent-module__0ce17q__consentText",
  "container": "ApplyFormConsent-module__0ce17q__container",
  "fadeInItems": "ApplyFormConsent-module__0ce17q__fadeInItems",
  "field": "ApplyFormConsent-module__0ce17q__field",
  "spacing--lg": "ApplyFormConsent-module__0ce17q__spacing--lg",
  "spacing--md": "ApplyFormConsent-module__0ce17q__spacing--md",
  "spacing--sm": "ApplyFormConsent-module__0ce17q__spacing--sm",
  "spacing--xl": "ApplyFormConsent-module__0ce17q__spacing--xl",
  "spacing--xs": "ApplyFormConsent-module__0ce17q__spacing--xs",
  "spacing--xxl": "ApplyFormConsent-module__0ce17q__spacing--xxl",
  "spacing--xxs": "ApplyFormConsent-module__0ce17q__spacing--xxs",
  "spacing--xxxl": "ApplyFormConsent-module__0ce17q__spacing--xxxl",
  "spacing--xxxs": "ApplyFormConsent-module__0ce17q__spacing--xxxs",
  "text": "ApplyFormConsent-module__0ce17q__text",
  "title": "ApplyFormConsent-module__0ce17q__title",
});
